import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TextField } from '@shared/ui/TextField';
import styles from './UserInvitationForm.module.scss';
import { Formik } from 'formik';
import { HelperText } from '@shared/ui/HelperText';
import { useTranslation } from 'react-i18next';
export function UserInvitationForm({ onSubmit }) {
    const { t } = useTranslation();
    const validate = useMemo(() => getValidate(t), [t]);
    return (_jsx(Formik, { initialValues: { email: '' }, onSubmit: onSubmit, validate: validate, children: ({ handleChange, handleBlur, handleSubmit, values, errors }) => (_jsxs("form", { id: FORM_ID, onSubmit: handleSubmit, noValidate: true, children: [_jsx(TextField, { className: styles.emailField, onChange: handleChange, onBlur: handleBlur, name: "email", type: "email", label: t('Email'), value: values.email, error: !!errors.email, helperText: errors.email || ' ', required: true, fullWidth: true }), _jsx(HelperText, { variant: "outlined", children: t('Add a new user for €49,99 per month and give them the power to automate takeoffs! Prorated pricing applies to your current billing cycle. T&C apply.') })] })) }));
}
const FORM_ID = 'invitation-form';
UserInvitationForm.FORM_ID = FORM_ID;
const getFieldValidations = (tUser) => {
    return {
        email: (email) => {
            const isValid = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email || '');
            if (!isValid) {
                return tUser('Please enter a valid e-mail address');
            }
            return undefined;
        }
    };
};
function getValidate(tUser) {
    const validateFnMap = getFieldValidations(tUser);
    return function (values) {
        const errors = {};
        const emailError = validateFnMap.email(values.email);
        if (emailError) {
            errors.email = emailError;
        }
        return errors;
    };
}
